<template>
  <div :class="{'exam-start-box': !isLoading}">
    <StatusRedirect
      status="BEFORE_TEST"
      @rewrite="(status) => checkApplicantStatus(status)"
    />
    <div v-if="applicantStatus === 'BEFORE_TEST'">
      <p>これはマイクロアドの新卒採用コードテストです</p>
      <p>受験開始ボタンを押すと、すぐ試験が開始されます</p>
      <p>試験時間は<b><font size=5>{{examMinute}}分</font></b>です</p>
      <!-- 直接、試験画面に飛ぶわけではなく実際はローディング画面が挟まるので要修正 -->
      <b-button
        class="exam-start-button"
        variant="primary"
        @click="callUpdateApplicantStatusAndRedirect()"
      >
        受験開始
      </b-button>
    </div>
    <Loading v-if="isLoading"/>
  </div>
</template>

<script>
import Loading from '@/main/frontend/pages/exam_start/Loading.vue';
import StatusRedirect from '@/main/frontend/components/StatusRedirect.vue';
import {updateApplicantStatusAndRedirect} from '@/main/frontend/repository/exam/common.ts';

export default {
  components: {
    Loading,
    StatusRedirect,
  },
  data() {
    return {
      applicantStatus: '',
      examMinute: null,
      isLoading: false,
      isRunningTimer: null,
    };
  },
  created() {
    this.$axios.get('/api/exam/minute')
      .then((res) => this.examMinute = res.data.value)
      // TODO: examMinuteが取得できないときのエラーハンドリング
      .catch(()=>{});
  },
  methods: {
    checkApplicantStatus(status) {
      this.applicantStatus = status;
    },
    callUpdateApplicantStatusAndRedirect() {
      this.applicantStatus = '';
      this.isLoading = true;
      this.$axios.post('/api/container/run')
        .then(() => {
          // コンテナがrunしているかを定期的に確認するタイマーを設置
          this.isRunningTimer = setInterval(() => {
            this.$axios.get('/api/container/is_container_running')
              .then((res) => {
                if (res.data && this.isLoading) {
                  clearInterval(this.isRunningTimer);
                  // コンテナの起動を確認してから数秒間スリープを入れる(code-serverの準備ができるまで待機)
                  const sleep = (msec) => new Promise((resolve) => setTimeout(resolve, msec));
                  (async () => {
                    await sleep(3000); // TODO: GCPのときこの秒数で問題ないか要確認
                    Promise.resolve()
                      .then(() => this.$axios.post('/api/exam/record_time')) // 試験時間をDBに保存
                      .then(() => {
                        this.isLoading = false;
                        updateApplicantStatusAndRedirect('DURING_TEST');
                      })
                      .catch(() => {
                      // TODO: postに失敗したときの処理
                      });
                  })();
                }
              });
          }, 200);
        })
        .catch((e) => {
          // TODO: run/is_runningがエラーのときの処理
          console.log(e);
        });
    },
  },
  destroyed() {
    clearInterval(this.isRunningTimer);
  },
};
</script>

<style>
.exam-start-box {
  left: 50%;
  position: fixed;
  text-align: center;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}
.exam-start-button {
  margin-top: 30px;
  width: 312px;
}
</style>
